import React, { useCallback, useEffect, useState } from 'react';
import './ImageViewerModal.css';

const clamp = (value, max) => Math.min(Math.max(value, 0), max);

const ImageViewerModal = ({ images = [], initialIndex = 0, alt = 'Image' }) => {
  const [index, setIndex] = useState(() => clamp(initialIndex, Math.max(images.length - 1, 0)));
  const hasMultiple = images.length > 1;

  const step = useCallback((delta) => {
    setIndex((current) => (current + delta + images.length) % images.length);
  }, [images.length]);

  // Escape is already handled by ModalService, so only arrows are bound here.
  useEffect(() => {
    if (!hasMultiple) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [hasMultiple, step]);

  if (!images.length) return null;

  return (
    <div className="image-viewer">
      <div className="image-viewer-stage">
        <img src={images[index]} alt={alt} className="image-viewer-image" />
      </div>
      {hasMultiple && (
        <div className="image-viewer-controls">
          <button
            type="button"
            className="image-viewer-nav"
            onClick={() => step(-1)}
            aria-label="Previous image"
          >
            &#8592;
          </button>
          <span className="image-viewer-counter">{index + 1} / {images.length}</span>
          <button
            type="button"
            className="image-viewer-nav"
            onClick={() => step(1)}
            aria-label="Next image"
          >
            &#8594;
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageViewerModal;
